import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class InputProjectAccessGroupGroupRelation<
  T extends EMode = EMode.entity
> {
  /** Alias: add */
  add?: number[];
  /** Alias: remove */
  remove?: number[];

  __typename?: string;
}

const fields: FieldDefinitions<InputProjectAccessGroupGroupRelation> = {
  add: {
    alias: 'add',
  },
  remove: {
    alias: 'remove',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputProjectAccessGroupGroupRelationEntityDefinition: EntitiyDefinition<InputProjectAccessGroupGroupRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputProjectAccessGroupGroupRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
